export interface ClientDto {
  ClientId: Guid;
  ClientName: string;
}

export class ClientDto {
  ClientId = "";
  ClientName = "";
}

export class ClientDetailDto implements ClientDto {
  ClientId = "";
  ClientName = "";
  ClientEmail: string | null = null;
  ClientCCEmail: string | null = null;
  ClientShortName: string | null = null;
  Active: boolean | null = null;
  Users: Array<string> = [];
}